import * as R from "ramda";
import { createHandlers } from "redux-mvc";
import { NAMESPACE, STEP_IDS } from "./constants";

const iniState = {
  showModal: false,
  stepId: STEP_IDS.SELECT_SOURCE,
  selectedSourceId: null,
  selectedConnectionId: null,
  loadingSettings: false,
  showMappedToModal: false,
  eventMapping: {},
  selectedExternalEventIds: [],
  externalEventMappings: {},

  // Connection Settings
  isEditingConnection: false,
  saving: false,
  connectionSettings: {},
  isConnected: false,
  connections: [],
  selectedConnectionConfigId: null,
  showNewConnectionForm: false,
  isNewConnectionValid: false,
  sessionboardEvents: [],
  integrationEvents: [],
  eventMappings: [],
  eventMappingType: null,
  eventMappingId: null,
  editConnection: null
};

const model = createHandlers({
  iniState,
  reducers: {
    init: R.identity,
    goToPreviousStep: R.identity,
    goToNextStep: R.identity,
    setCurrentPage: R.identity,
    loadConnections: R.identity,
    addConnection: R.identity,
    removeConnection: R.identity,
    showModal: () => ({
      showModal: true,
      stepId: STEP_IDS.SELECT_SOURCE,
      selectedSourceId: null
    }),
    hideModal: () => ({
      showModal: false,
      stepId: STEP_IDS.SELECT_SOURCE,
      selectedSourceId: null
    }),
    toggleSelectedExternalEvent: (state, { payload: eventId }) => ({
      selectedExternalEventIds: state.selectedExternalEventIds.includes(eventId)
        ? R.without([eventId], state.selectedExternalEventIds)
        : R.concat([eventId], state.selectedExternalEventIds)
    }),
    selectAllExternalEvents: state => ({
      selectedExternalEventIds: state.integrationEvents.map(event => event.id)
    }),
    deselectAllExternalEvents: () => ({
      selectedExternalEventIds: []
    }),
    updateMappingForExternalEvent: (
      state,
      { payload: { eventId, sbEventId } }
    ) => ({
      externalEventMappings: {
        ...state.externalEventMappings,
        [eventId]: sbEventId
      }
    })
  },
  namespace: NAMESPACE
});

const { actions, getters } = model;

export { actions, getters };

export default model;
